import { NativeDevice } from 'react-native-ble-plx';

export default class MockModel implements NativeDevice {
  name!: string;
  rssi!: number;
  mtu!: number;
  manufacturerData!: string;
  serviceData!: { [uuid: string]: string };
  serviceUUIDs!: string[];
  localName!: string;
  txPowerLevel!: number;
  solicitedServiceUUIDs!: string[];
  isConnectable!: boolean;
  overflowServiceUUIDs!: string[];
  id!: string;
  macAddress!: any;
}
